import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AgendamentoDespesaEditarComponent } from './agendamento-despesa-editar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: AgendamentoDespesaEditarComponent }
    ])],
    exports: [RouterModule]
})
export class AgendamentoDespesaEditarRoutingModule { }
